
import React from 'react';

export const Sun = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 256 256"
      xmlSpace="preserve"
      style={{ overflow: 'visible' }}
    >
      <style>
        {`
          #rotatingPath {
            animation: rotatePath 4s linear infinite;
            transform-origin: 17.5% 17.5%;
          }

          @keyframes rotatePath {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      <g
        style={{
          stroke: 'none',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'none',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          id="rotatingPath"
          d="M 33.401 89.585 c -0.4 0 -0.803 -0.057 -1.196 -0.172 c -1.325 -0.389 -2.382 -1.401 -2.829 -2.708 l -3.114 -9.121 c -0.34 -0.997 -1.315 -1.628 -2.359 -1.516 l -9.59 0.956 c -1.372 0.131 -2.733 -0.403 -3.637 -1.447 C 9.77 74.534 9.428 73.11 9.759 71.77 l 2.311 -9.357 c 0.252 -1.022 -0.227 -2.071 -1.165 -2.55 l -8.585 -4.381 c -1.23 -0.628 -2.082 -1.818 -2.278 -3.185 c -0.197 -1.367 0.285 -2.749 1.288 -3.698 l 7.003 -6.621 c 0.765 -0.724 0.929 -1.865 0.399 -2.775 L 3.88 30.877 c -0.696 -1.192 -0.768 -2.655 -0.194 -3.911 c 0.573 -1.256 1.726 -2.159 3.083 -2.414 l 9.471 -1.785 c 1.035 -0.195 1.79 -1.066 1.836 -2.119 l 0.418 -9.629 c 0.06 -1.379 0.789 -2.649 1.951 -3.395 c 1.161 -0.747 2.62 -0.882 3.899 -0.364 l 8.932 3.619 c 0.977 0.396 2.083 0.071 2.69 -0.79 l 5.558 -7.874 c 0.796 -1.128 2.095 -1.801 3.476 -1.801 c 0 0 0 0 0.001 0 c 1.381 0 2.681 0.673 3.477 1.801 l 0.001 0 l 5.558 7.874 c 0.606 0.86 1.714 1.188 2.689 0.79 l 8.933 -3.619 c 1.279 -0.519 2.737 -0.383 3.898 0.364 c 1.162 0.747 1.892 2.016 1.951 3.396 l 0.419 9.629 c 0.046 1.052 0.801 1.924 1.836 2.119 l 9.471 1.785 c 1.356 0.255 2.509 1.158 3.083 2.414 c 0.573 1.256 0.501 2.718 -0.194 3.911 l -4.854 8.326 c -0.53 0.91 -0.366 2.052 0.398 2.775 l 7.003 6.621 c 1.003 0.949 1.485 2.331 1.288 3.698 c -0.196 1.366 -1.048 2.557 -2.278 3.185 l -8.584 4.381 c -0.938 0.479 -1.417 1.527 -1.165 2.551 l 2.312 9.355 c 0.331 1.342 -0.012 2.766 -0.916 3.809 c -0.904 1.044 -2.262 1.581 -3.638 1.447 l -9.59 -0.956 c -1.046 -0.11 -2.017 0.52 -2.358 1.516 l -3.114 9.121 c -0.446 1.307 -1.504 2.319 -2.829 2.708 c -1.324 0.388 -2.762 0.107 -3.843 -0.75 l -7.55 -5.988 c -0.826 -0.654 -1.979 -0.654 -2.804 0 l -7.551 5.988 C 35.287 89.267 34.35 89.585 33.401 89.585 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: 'rgb(255,169,65)',
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
        />
        <path
          d="M 45 71.001 c -14.337 0 -26 -11.663 -26 -26 c 0 -14.337 11.664 -26 26 -26 c 14.337 0 26 11.664 26 26 C 71 59.338 59.337 71.001 45 71.001 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: 'rgb(255,222,85)',
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
        />
        <path
          d="M 45.536 54.83 c -1.251 0 -2.439 -0.191 -3.561 -0.573 c -3.278 -1.117 -6.005 -3.871 -8.108 -8.187 c -0.242 -0.496 -0.036 -1.095 0.461 -1.336 c 0.497 -0.243 1.096 -0.035 1.337 0.461 c 1.86 3.819 4.2 6.23 6.954 7.169 c 2.755 0.938 6.081 0.455 9.885 -1.433 c 0.494 -0.246 1.094 -0.044 1.34 0.451 c 0.246 0.494 0.044 1.095 -0.451 1.34 C 50.566 54.126 47.937 54.83 45.536 54.83 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: 'rgb(255,169,65)',
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round"
          />
          <path
            d="M 44.404 38.994 c -0.327 0 -0.646 -0.16 -0.838 -0.453 c -1.628 -2.494 -3.698 -3.198 -6.509 -2.217 c -0.521 0.181 -1.092 -0.094 -1.273 -0.615 c -0.182 -0.521 0.094 -1.091 0.615 -1.273 c 3.662 -1.278 6.72 -0.236 8.842 3.012 c 0.302 0.462 0.172 1.082 -0.291 1.384 C 44.781 38.942 44.591 38.994 44.404 38.994 z"
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeLinejoin: 'miter',
              strokeMiterlimit: 10,
              fill: 'rgb(255,169,65)',
              fillRule: 'nonzero',
              opacity: 1,
            }}
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <path
            d="M 57.656 43.509 c -0.326 0 -0.646 -0.159 -0.838 -0.453 c -1.629 -2.493 -3.699 -3.198 -6.51 -2.217 c -0.523 0.183 -1.092 -0.093 -1.273 -0.615 c -0.182 -0.521 0.094 -1.092 0.615 -1.273 c 3.664 -1.278 6.721 -0.235 8.842 3.012 c 0.303 0.462 0.173 1.082 -0.29 1.384 C 58.033 43.456 57.844 43.509 57.656 43.509 z"
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeLinejoin: 'miter',
              strokeMiterlimit: 10,
              fill: 'rgb(255,169,65)',
              fillRule: 'nonzero',
              opacity: 1,
            }}
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <g transform="matrix(1.43073,0.63495,-0.63495,1.43073,47.4681,42.0257)">
            <g transform="matrix(1,0,0,1,-16.135,-16.135)">
              <clipPath id="_clip1">
                <rect x="0" y="0" width="32.27" height="32.27" />
              </clipPath>
              <g clipPath="url(#_clip1)">
                <g>
                  <g>
                    <path
                      d="M31.686,13.895C31.484,14.314 31.148,14.643 31.015,15.038C30.863,15.486 30.835,16.03 30.746,16.515C30.492,17.884 30.229,19.38 29.337,20.204C28.594,20.887 26.754,21.435 25.441,21.546C20.743,21.926 18.795,19.587 17.662,16.38C17.318,15.413 17.192,14.398 15.918,14.501C14.896,14.584 14.85,15.417 14.439,16.647C13.559,19.304 11.918,21.349 8.538,21.61C6.551,21.761 4.12,21.358 3.102,20.403C2.16,19.513 1.821,17.72 1.494,16.109C1.374,15.521 1.235,15.269 0.957,14.837C0.826,14.631 0.726,14.459 0.622,14.232C0.251,13.414 -0.255,12.567 0.15,11.414C4.496,10.716 8.374,10.726 12.295,11.48C13.546,11.72 14.816,12.122 16.053,12.151C17.496,12.186 19.242,11.63 20.615,11.346C24.212,10.606 28.146,10.284 32.09,11.145C32.507,12.19 32.128,12.973 31.686,13.895Z"
                      style={{ fill: 'rgb(1,0,2)', fillRule: 'nonzero' }}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  };
  